module.exports = __webpack_public_path__ + "static/img/zone-de-contact-2.da2db6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/zone-de-contact-2.jpg
// module id = SP/Y
// module chunks = 0